import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const fetchIncompletePHOApplicationDataModuleActions = createDataModuleActions(
    'FETCH_INCOMPLETE_PHO_APPLICATION',
);
export const fetchIncompletePHOApplicationForDataModule =
    fetchIncompletePHOApplicationDataModuleActions.dataRequest;
export const fetchIncompletePHOApplicationSuccess =
    fetchIncompletePHOApplicationDataModuleActions.dataSuccess;
export const fetchIncompletePHOApplicationError =
    fetchIncompletePHOApplicationDataModuleActions.dataError;
export const fetchIncompletePHOApplicationReset =
    fetchIncompletePHOApplicationDataModuleActions.dataReset;
